import { render, staticRenderFns } from "./DeparturesPage.vue?vue&type=template&id=79615c0a&scoped=true&"
import script from "./DeparturesPage.vue?vue&type=script&lang=js&"
export * from "./DeparturesPage.vue?vue&type=script&lang=js&"
import style0 from "./DeparturesPage.vue?vue&type=style&index=0&id=79615c0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79615c0a",
  null
  
)

export default component.exports